<ng-select [items]="tenors"
           [hideSelected]="true"
           [searchable]="false"
           [clearable]="false"
           bindLabel="name"
           bindValue="value"
           (ngModelChange)="emitChange($event)"
           [(ngModel)]="selectedTenorId"
           class="sixletter-dropdown-pricebox">
  <ng-template ng-option-tmp let-item="item">{{item.value | translate}}</ng-template>
</ng-select>
